import { useNavigate } from "react-router-dom";
import { useRef, useEffect } from "react";

const useStrictNavigation = () => {
  const navigate = useNavigate();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const strictNavigate = (targetUrl: string, options = {}) => {
    if (isMountedRef.current) {
      navigate(targetUrl, options);
    }
  };

  return strictNavigate;
};

export default useStrictNavigation;
